export default __webpack_public_path__ + "static/media/CFD214.6f6d7911.jpg";